import React, { Component } from 'react';
import DateTime from 'react-datetime';
import jQuery from 'jquery';

import './../../../node_modules/react-datetime/css/react-datetime.css';

import Core from './../../Core/Core';

class UserModal extends Component
{
    constructor(props)
    {
        super(props);

        //start date
        var start_date = new Date();
        start_date.setDate(1);
        start_date.setMonth(start_date.getMonth()-1);
        start_date.setHours(0);
        start_date.setMinutes(0);

        //end date
        var end_date = new Date();
        end_date.setHours(23);
        end_date.setMinutes(59);

        this.state = {
            start: start_date.getTime() / 1000 ,
            end: end_date.getTime() / 1000,
            logs: 0
        };

        this.handleDate = this.handleDate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getLogs = this.getLogs.bind(this);
        this.DateTimeStart = React.createRef();
        this.DateTimeEnd = React.createRef();
    }
    
    componentDidMount(){
        const modalName= "#user"+this.props.index;
        jQuery(modalName).on('show.bs.modal', function (e) {
            this.getLogs();
        }.bind(this))
    }

    handleDate(ref, name, date) {
        if (date._isAMomentObject != null) {
          let evt = {
            target: {
              name: name,
              value: date.unix()
            },
          };
          this.handleChange(evt);
        } else if(date === ""){
          let evt = {
            target: {
              name: name,
              value: null
            },
          };
          this.handleChange(evt);
        }
    }

    handleChange(event)
    {
        this.setState({
            [event.target.name]:  event.target.value
        }, () => this.getLogs());
    }

    getLogs()
    {   
        let request = Core.Address + 'Logs_maeva/User_id/' + this.props.index;
        Core.Instance.Request(request, null, 'GET').then((json) => {
            if(json){
                let paths = json.filter((item) => (item.date > this.state.start && item.date < this.state.end));
                
                this.setState({
                    logs: paths != null ? paths.length : 0
                });
            }else {
                this.setState({
                    logs: 0
                });
            }
        });
    }

    render()
    {
        return (
            <div className="modal fade" id={ "user"+this.props.index } tabIndex="-1" role="dialog" aria-labelledby={ "#userTitle"+this.props.index } aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header bg-light">
                            <span className="modal-title h5" id={ "userTitle"+this.props.index }>Imports</span>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mx-2 row">
                                <span className='my-auto'>Du :</span>
                                <div className='mr-2' ref={this.DateTimeStart} style={{ width: '110px' }}>
                                    <DateTime
                                        name='date'
                                        timeFormat={false}
                                        onChange={(date) => {
                                        this.handleDate(this.DateTimeStart, 'start', date);
                                        }}
                                        dateFormat='DD/MM/YYYY'
                                        locale='fr'
                                        value={this.state.start != null ? this.state.start * 1000 : null}
                                        closeOnSelect={true}
                                    />
                                </div>
                                <span className='my-auto'>au :</span>
                                <div className='mr-2' ref={this.DateTimeEnd} style={{ width: '110px' }}>
                                    <DateTime
                                        name='date'
                                        timeFormat={false}
                                        onChange={(date) => {
                                        this.handleDate(this.DateTimeEnd, 'end', date);
                                        }}
                                        dateFormat='DD/MM/YYYY'
                                        locale='fr'
                                        value={this.state.end!= null ? this.state.end * 1000 : null}
                                        closeOnSelect={true}
                                    />
                                </div>
                                <span className='my-auto'>inclus</span>
                            </div>                       
                            <div className="mx-2 mt-3 row">
                                <span className="h6 text-muted col-5 pl-0">Nombre d'imports</span>
                                <span className="col-7">{ this.state.logs }</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default UserModal;



// WEBPACK FOOTER //
// ./src/Components/User/UserModal.js